import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=6fd8a75c&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=6fd8a75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd8a75c",
  null
  
)

export default component.exports